import restClient from "api/restClient";
import NotificationService from "components/Notification/Notification.service";
import RestErrorNotification from "components/Notification/RestErrorNotification";
import { actions as pluginActionActions } from "components/PluginsPopover/Plugin.reducer";
import { call, takeEvery } from "redux-saga/effects";

export function* callPluginAction({ promise, pluginAction, data }) {
    try {
        const path = `/plugin_action/${pluginAction?.id}/call_${pluginAction?.type?.toLowerCase()}`;
        // trackAction: block tab-close/navigation until this request settles, so
        // closing the tab too early can't abort it before the execution is created.
        const response = yield restClient.post(path, data, { trackAction: true });
        yield call(promise.resolve, response?.data);
    } catch (error) {
        NotificationService.error(<RestErrorNotification titleOverride="Plugin action failed" error={error} />);
        yield call(promise.reject, error?.response?.data || error);
    }
}

export default [takeEvery(pluginActionActions.CALL_PLUGIN_ACTION, callPluginAction)];
